import { useEffect } from "react";
import "@/App.css";
import { Navbar } from "@/components/portfolio/Navbar";
import { Hero } from "@/components/portfolio/Hero";
import { Metrics } from "@/components/portfolio/Metrics";
import { About } from "@/components/portfolio/About";
import { Experience } from "@/components/portfolio/Experience";
import { Projects } from "@/components/portfolio/Projects";
import { Skills } from "@/components/portfolio/Skills";
import { OpenSource } from "@/components/portfolio/OpenSource";
import { Timeline } from "@/components/portfolio/Timeline";
import { Footer } from "@/components/portfolio/Footer";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App" data-testid="portfolio-app">
      <Navbar />
      <main>
        <Hero />
        <Metrics />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <OpenSource />
        <Timeline />
      </main>
      <Footer />
    </div>
  );
}

export default App;
